export const replaceArrayElement = <T>(arr: T[], el: T, key: keyof T) => {
  const newArray = arr.reduce((acc, current) => {
    if (current[key] === el[key]) {
      return [...acc, el];
    }
    return [...acc, current];
  }, []);
  return newArray;
};
